"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringCondition = void 0;
const PrimitivePropertyCondition_1 = require("./PrimitivePropertyCondition");
class StringCondition extends PrimitivePropertyCondition_1.PrimitivePropertyCondition {
    constructor(property) {
        super(property, "string");
        this.isNonEmpty = false;
    }
    nonEmpty() {
        this.isNonEmpty = true;
        return this;
    }
    matchRegex(regex) {
        this.regex = regex;
        return this;
    }
    isFulfilled(value) {
        const superResult = super.isFulfilled(value);
        if (!superResult.fulfilled) {
            return superResult;
        }
        if (this.passesNullOrUndefined(value)) {
            return { fulfilled: true };
        }
        if (this.isNonEmpty && value[this.property].length === 0) {
            return this.createUnfulfilledResult(value, "is empty");
        }
        if (this.regex && !this.regex.test(value[this.property])) {
            return this.createUnfulfilledResult(value, `does not match regular expression ${this.regex.toString()}`);
        }
        return { fulfilled: true };
    }
}
exports.StringCondition = StringCondition;
//# sourceMappingURL=StringCondition.js.map